import React, { useEffect } from "react";
import { reduxForm } from "redux-form";
import { connect } from "react-redux";

import { resetField } from "../../../../store/actions";
import AddRecipeTabs from "./addRecipeTabs";

const AdminAddRecipe = ({ resetField, match }) => {
	useEffect(() => {
		return () => {
			resetField("Recipes.recipeDetails", {});
		};
	}, [resetField]);

	const isAdding = match && match.path.indexOf("/add") > -1 ? true : false;

	return (
		<section className="page page-add-recipe">
			<div className="container">
				<h3 className="m-0 mt-2">{isAdding ? "Add" : "Edit"} Recipe</h3>
				<div className="card-wrap">
					<div className="add-recipe-tab-container tab-primary card card-primary w-100">
						<AddRecipeTabs />
					</div>
				</div>
			</div>
		</section>
	);
};

const mapStateToProps = (state) => {
	return {
		AddRecipe: state.AddRecipe
	};
};

const mapDispatchToProps = {
	resetField
};

export default reduxForm({
	form: "AddRecipe"
})(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(AdminAddRecipe)
);
